
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, HostListener, OnInit, Output, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { parseDate } from 'ngx-bootstrap/chronos';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { throwError as observableThrowError } from 'rxjs';
//import { AuthService } from 'angularx-social-login';
//import { SocialUser } from 'angularx-social-login';
//import { GoogleLoginProvider, FacebookLoginProvider, LinkedInLoginProvider } from 'angularx-social-login';
import { environment } from '../../../environments/environment';
import { AppComponent } from '../../app.component';
import { IPropertySearchCriteria } from '../../shared/models/propertysearchcriteria';
import { ISavedSearchOutputModel } from '../../shared/models/SavedSearchOutputModel';
//import { UserManagerService } from '../../shared/providers/user-manager.service';
import { IUserDetails } from '../../shared/models/UserDetailsOutputModel';
import { CommonService } from '../../shared/providers/common.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { ToastService } from '../../shared/providers/toast.service';
import { ValidationService } from '../../shared/providers/validation.service';
import { AuthService } from '../auth/auth.service';
import { AuthenticationService } from '../auth/authentication.service';
import { AllReceivedMessageInputModel, AllReceivedMessageTimeline } from '../models/AllReceivedMessageInputModel';
import { INotificationAction } from '../models/INotificationAction';
import { IIntercomConfig } from '../models/IntercomModel';
import { MessageGroupCreateInputModel } from '../models/MessageGroupCreateInputModel';
import { IMessageGroupInputModel } from '../models/MessageGroupInputModel';
import { IMessageGroupMemberInputModel } from '../models/MessageGroupMemberInputModel';
import { IMessageInput } from '../models/MessageInputModel';
import { MessageUserListOutModel } from '../models/MessageUserListOutputModel';
import { NotificationRequestModel } from '../models/NotificationRequestModel';
import { IPropertyChatModel } from '../models/PropertyChatModel';
import { IPropertyDetails } from '../models/propertydetails';
import { IUser } from '../models/user';
import { RestService } from '../providers/rest.service';
import { SharedService } from '../providers/shared.service';
import { UserManagerService } from '../providers/user-manager.service';
import { RouterModule } from '@angular/router';  // Import RouterModule
import { Actions, Modules } from '../../shared/enum/enum';
import { PermissionService } from '../../shared/providers/permission.service';
declare function gtag(config, key): any;




@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})



export class HeaderComponent implements OnInit {
  isUserLoggedIn = false;
  messageAll: string[];
  loggedInUser: string = "";
  loggedInUserPic: string = "";
  loggedInUserRole: string = "";
  userDetailsOutput = {} as IUserDetails;
  intercomModel = {} as IIntercomConfig;
  authResponse = {} as IUser;
  modalRef: BsModalRef;
  modalRefInvitePrincipal: BsModalRef;
  Modules = Modules;
  Actions = Actions;
  modalSubscribeRef: BsModalRef;
  modalRefTC: BsModalRef;
  modalBuyerQuestionnaire: BsModalRef;
  savedSearchOutputModelList: ISavedSearchOutputModel[];
  modalIsEBRA: BsModalRef;
  @Output() propertySearchCriteria = new EventEmitter<IPropertySearchCriteria>();
  searchCriteria = {} as IPropertySearchCriteria;
  messages: AllReceivedMessageTimeline[];
  openChats = [];
  isPendingBuyerQuestions = false;
  canShowUserMenu = false;
  canShowSaveSearch = false;
  canShow1031Trade = false;
  canShowFavorites = false;
  notifications = [] as any;
  canShowOpportunities = false;
  canShowDocAccessRequest = false;
  canShowMyProperties = false;
  canShowMy1031Exchange = false;
  canShowMyOffers = false;
  canShowMasters = false;
  hasMyportfolioAccess = false;
  selectedIndex = -1;
  canShowSaveSearchText = false;
  bindMenus = false;
  messageGroupMember = {} as IMessageGroupMemberInputModel;
  messageGroupMembers: IMessageGroupMemberInputModel[] = [];
  messageGroupSingleData = {} as IMessageGroupInputModel;
  messageGroupDataLst = {} as MessageGroupCreateInputModel;
  propertyContactPerson: MessageUserListOutModel[] = [];
  notificationAction = {} as INotificationAction;

  selectedExchangeId: number = 0;
  selectedGroupId: number;
  TimelineView: boolean = true;
  TermsandConditionModified: Date | null;
  dtOptions = {};
  prevPage = '';
  dt: any = {};
  searchVal: string = "";
  activeAccordian: string = "";
  currentPage: number = 0;
  GroupDataForSupress;
  messageListForSupress;
  totalUnReadMessages = 0;
  totalUnreadGroupMessages = 0;
  totalUnreadIndividualMessages = 0;
  totalMCount: number = 0;
  exchangeId = 0;
  userid = 0;
  currentStage = 5;
  public buypage: string = 'buy';
  cuurentOpenTab: number = 0;
  public config = {
    newLineOnEnter: false,
    character: '#',
    emptyListPlaceholder: 'No Properties Found'
  };

  protected readonly BASE_URL: string = environment.base_url;
  allMessageList: AllReceivedMessageInputModel[] = [];
  filterMessageList: AllReceivedMessageInputModel[] = [];
  messageTimeLineData: AllReceivedMessageTimeline[] = [];
  property: IPropertyDetails;
  filterByExchangeId: any = [];

  public opened_menu: any = [];

  public opened_saveSearchMenu_menu = null;
  toggle_opened_menu(classname) {
    let mainClassName = classname;
    if (classname == 'exchangeDashboard1031') {
      classname = 'buy-prop';
    }

    if (classname != 'savedsearches' && classname != 'offermenu') {
      if (this.opened_menu.filter(i => i == classname).length > 0) {
        const index: number = this.opened_menu.indexOf(classname);
        if (index !== -1) {
          this.opened_menu.splice(index, 1);
        }
        this.opened_saveSearchMenu_menu = null;
      }
      else {
        this.opened_saveSearchMenu_menu = null;
        this.opened_menu.push(classname);
      }
    }
    else if (this.opened_saveSearchMenu_menu == classname) {
      if (this.opened_menu.filter(i => i == classname).length > 0) {
        const index: number = this.opened_menu.indexOf(classname);
        if (index !== -1) {
          this.opened_menu.splice(index, 1);
        }
        this.opened_saveSearchMenu_menu = null;
      }
    }
    else {
      this.opened_saveSearchMenu_menu = classname;
      this.opened_menu.push(classname);
    }

    if ((classname == 'MyPortfolio' || classname == "sell" || classname == "buy-prop") && mainClassName != 'exchangeDashboard1031') {
      let openedMenuStatus = this.checkMenuOpened(classname);
      if (openedMenuStatus) {
        if (classname == 'MyPortfolio') {
          this.closeMenu(1);
        }
        else {
          this.redirectMainPage(classname);
        }
      }
    }
  }

  redirectMainPage(currentSubMenu: string = '') {
    if ($(window).width() < 1000) {
      document.body.classList.remove('open-sidemenu');
    }

    if (currentSubMenu != '' && currentSubMenu != null) {
      if (currentSubMenu == 'buy-prop') {
        this.router.navigate(['/propertylisting'], { queryParams: { request: 'buy' } })
      }
      else if (currentSubMenu == 'sell') {
        if (this.router.url.indexOf('/seller/dashboard') <= -1) {
          this.router.navigate(['/seller/dashboard']);
        }
      }
    }
  }


  closeMenu(currentSubMenu: number = 0) {
    if ($(window).width() < 1000) {
      document.body.classList.remove('open-sidemenu');
    }
    this.cuurentOpenTab = 1;
    if (currentSubMenu >= 1) {
      let userGuid = this.user.Guid;
      let currentUrl = this.router.url;
      if (currentUrl != null && currentUrl != '' && currentUrl.indexOf('/market-snapshot') > -1 && currentUrl.indexOf('UserGuid') > -1) {
        let Id = '';
        this.activatedRoute.queryParams.subscribe((params: Params) => {
          Id = params['UserGuid'] ?? '';
        });
        userGuid = (Id != null && Id != undefined && Id != '') ? Id : userGuid;
      }
      this.router.navigate(['/market-snapshot'], { queryParams: { UserGuid: userGuid, opentab: currentSubMenu } });
    }
  }

  checkMenuOpened(className) {
    return this.opened_menu.filter(i => i == className).length > 0 ? true : false;
  }

  redirect = false;
  @ViewChild('templateAuth0ResetPassword', { static: true }) passwordReset: TemplateRef<null>;
  //@ViewChild('unresolvedFlag') unresolvedFlagModal: TemplateRef<any>;
  @ViewChild('unresolvedFlag', { static: true }) unresolvedFlagModal: TemplateRef<any>;
  @ViewChild('pendingBuyerQuestionnaire', { static: true }) pendingBuyerQuestionnaireFlagModal: TemplateRef<any>;
  @ViewChild('ShowEBRAModel', { static: true }) EBRAModal: TemplateRef<any>;


  result: any;
  firstName: string;
  lastName: string;
  companyName: string;
  email: string;
  isValidEmail = true as boolean;
  validFname = true as boolean;
  validLname = true as boolean;
  loadPopus = false;
  messageInput = {} as IMessageInput;

  propertyId: number;
  propertyChatModel = {} as IPropertyChatModel;
  messageList = [];
  constructor(private renderer: Renderer2, public authService: AuthenticationService,
    public Auth0: AuthService,
    public router: Router,
    private modalService: BsModalService,
    private _toastService: ToastService,
    private _propertyListingService: PropertyListingService,
    private _userManagerService: UserManagerService,
    private activatedRoute: ActivatedRoute,
    public Validation: ValidationService,
    // private socialAuthService: AuthService,
    private parent: AppComponent,
    private PropertyManagement: PropertyManagementService,
    private _http: HttpClient,
    private recaptchaV3Service: ReCaptchaV3Service,
    private _commonService: CommonService,
    private _loaderService: LoaderService,
    private _restService: RestService,
    private sharedService: SharedService,
    public permissionService: PermissionService

  ) {
    this.user = authService.user;
  }
  sendMessage(message) {
    this.saveMessage(message, "");
  }
  setSelected(id: number) {
    this.selectedIndex = id;
  }

  openMenu() {
    $("body").toggleClass("open-sidemenu");
  }
  CollapeMenu() {
    if (window.innerWidth > 1024) {
      if (document.body.classList.contains('menu-collapse')) {
        sessionStorage.setItem('collapseHeader', '1');
        this.renderer.removeClass(document.body, 'menu-collapse');
      } else {
        sessionStorage.setItem('collapseHeader', '2');
        this.renderer.addClass(document.body, 'menu-collapse');
      }
    }
  }
  checkCurrentPage(pageUrl) {
    return this.parent.currentPage.indexOf(pageUrl) > -1;
  }
  checkCurrentRoute(pageUrl) {
    return this.router.url.indexOf(pageUrl) > -1;
  }
  Is1031DashboardEnabled = false;
  Is1031InquirySubmitted = false;
  hasOpenedExchange = false;
  showPortfiloMenu = false;
  isAccountVerified = false;
  user: any;
  @ViewChild('OpenChat') private content: TemplateRef<any>;

  ngOnInit() {
    this.isNotificationAPICalled = false;
    this.isNotificationMessageAPICalled = false;
    this.isOpenExchangeAPICalled = false;
    this.isUserSearchAPICalled = false;
    this.isCheckMyPortfolioAPICalled = false;
    this.isTAndCAPICalled = false;
    this.isUserDetailsAPICalled = false;
    this.sharedService.messageValueClicked.subscribe(res => {

      if (res != null && res != undefined && Number(res) != 0) {
        this.propertyChatModel = res;
        this.exchangeId = res.ExchangeId;
        this.userid = res.userid;
        this.getPropertyDetail(this.propertyChatModel);
      }
    });
    this.Auth0.openMenuinHeader.subscribe(x => {
      this.toggle_opened_menu(x);
    });
    let collapseHeader = sessionStorage.getItem('collapseHeader');

    if (collapseHeader != null && collapseHeader != undefined) {
      if (collapseHeader == '1') {
        if (document.body.classList.contains('menu-collapse')) {
          this.renderer.removeClass(document.body, 'menu-collapse');
        }
        $("body").addClass('open-sidemenu');
      }
      else {
        this.renderer.addClass(document.body, 'menu-collapse');
      }
    }
    this.Auth0.passwordReset = this.passwordReset;
    this.Auth0.unresolvedFlagModal = this.unresolvedFlagModal;
    this.Auth0.pendingBuyerQuestionnaireFlagModal = this.pendingBuyerQuestionnaireFlagModal;
    this.Auth0.EBRAModal = this.EBRAModal;
    this.authService.isLoggedIn.subscribe(response => {
      this.isUserLoggedIn = response;
      if (this.isUserLoggedIn) {

        const notRegisteredElement = document.getElementById('list_notRegistered');
        const registeredElement = document.getElementById('list_Registered');
        if (notRegisteredElement) {
          notRegisteredElement.classList.add('hide_notRegisteredUsers');
        }
        if (registeredElement) {
          registeredElement.classList.remove('hide_notRegisteredUsers');
        }
        this.setHamburgerMenu();
        // -- auth0 ----//
        var date: any = new Date().getTime();
        var time: any = localStorage.getItem('tokenRefreshTime');
        var status: any = localStorage.getItem('isTokenExpired');
        var timediff = (date - new Date(time).getTime()) / 1000;
        var timediff = timediff / 60;

        if ((timediff > environment.auth0.tokenRefreshTime || status == 'true') && this.authService.isAuth0Enabled) {
          this.Auth0.checkAuthentication();
        }
        // -- auth0 ----//

        this.user = this.authService.user;
        this.setLoggedInUserDetails();

        if (!this.isCheckMyPortfolioAPICalled) {
          this.isCheckMyPortfolioAPICalled = true;
          this.CheckMyPortfolioAccess();
        }

        this.setMenuPermissions(this.loggedInUserRole);
        if (!this.isUserSearchAPICalled) {
          this.isUserSearchAPICalled = true;
          this.bindSaveSearchtoMenu();
        }
        //  this.intercom.shutdown();
        //  this.showIntercomChatbox();
      }
      else {
        const notRegisteredElement = document.getElementById('list_notRegistered');
        const registeredElement = document.getElementById('list_Registered');
        if (notRegisteredElement) {
          notRegisteredElement.classList.remove('hide_notRegisteredUsers');
        }
        if (registeredElement) {
          registeredElement.classList.add('hide_notRegisteredUsers');
        }
      }
    });


    //this.getTrakingCode();
    if (this.isUserLoggedIn) {
      //// this.getUnreadMessageCount();
      //// this.getUnreadNotificationCount();
      if (!this.isOpenExchangeAPICalled) {
        this.isOpenExchangeAPICalled = true;
        this.checkOpenExchange();
      }
    }
    //Below code will execute when logged in user details are executed from my profile page
    this.authService.loggedInUserDetails.subscribe(res => {
      if (res == true) { // if user details changed
        let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
        this._userManagerService.getUserDetails(loggedUserDetails.Guid).subscribe(response => {
          this.userDetailsOutput = response;
          this.authResponse = loggedUserDetails;
          this.authResponse.FirstName = this.userDetailsOutput.FirstName;
          this.authResponse.LastName = this.userDetailsOutput.LastName == null ? '' : this.userDetailsOutput.LastName;
          this.authResponse.ProfilePicturePath = this.userDetailsOutput.ProfilePicPath;
          this.authResponse.CompanyName = this.userDetailsOutput.CompanyName;
          this.authResponse.PhoneNumber = this.userDetailsOutput.Phoneno;
          this.authResponse.Role = this.userDetailsOutput.UserRole;
          this.authResponse.RoleId = this.userDetailsOutput.UserRoleId;
          this.authResponse.RoleIdList = this.userDetailsOutput.UserRoleIdList;
          if (this.authService.Principal || this.authService.Principal1031) {
            /*if (this.userDetailsOutput.IsMyPortfolioEnabled != null && this.userDetailsOutput.IsMyPortfolioEnabled) {*/
            this.showPortfiloMenu = true;
            //}
            //else {
            //  this.showPortfiloMenu = false;
            //}
          }

          //if (this.userDetailsOutput.UserRole === environment.brokerRoleName) {
          //    this.authResponse.Role = "Broker";
          //}
          //else {
          //     this.authResponse.Role = this.userDetailsOutput.UserRole;
          //}

          localStorage.removeItem('currentUser');
          localStorage.setItem('currentUser', JSON.stringify(this.authResponse));
          this.authService.updateUserDetails(this.authResponse);
          this.setLoggedInUserDetails();
          this.authService.reloadUserDetails(false);
          //// this.getUnreadMessageCount();
          ////this.getUnreadNotificationCount();
          if (!this.isOpenExchangeAPICalled) {
            this.isOpenExchangeAPICalled = true;
            this.checkOpenExchange();
          }
        });
      }
    });

    //Below code will execute when saved search button is clicked
    this._propertyListingService.saveSearchUpdateStatus.subscribe(res => {
      if (res == true) { // if save search button is clicked then bind the menu
        //if (!this.isUserSearchAPICalled) {
        //  this.isUserSearchAPICalled = true;
        this.bindSaveSearchtoMenu();
        this._propertyListingService.UpdateSaveSearch(false);
        /*}*/
      }
    });
  }

  //showIntercomChatbox() {
  //  this._commonService.getIntercomConfigDetails().subscribe(res => {
  //    this.intercomModel = res
  //    if (this.intercomModel.ShowIntercom == "True") {
  //      if (this.isUserLoggedIn) {
  //        this.intercom.boot({
  //          app_id: this.intercomModel.App_id,
  //          user_id: this.user.Id,
  //          email: this.user.Email,
  //          name: this.user.name,
  //        });
  //      }
  //      else {
  //        this.intercom.boot({
  //          app_id: this.intercomModel.App_id,
  //          widget: {
  //            "activator": "#intercom"
  //          }
  //        });
  //      }
  //    }
  //  })
  //}

  getPropertyDetail(propertyChatModel) {
    if (propertyChatModel.PropertyGuid != null) {
      this._propertyListingService.getPropertyDetails(propertyChatModel.PropertyGuid, this.user.Id, true).subscribe(responds => {
        this.propertyId = responds.Id;
        this.property = responds;
        this.openModalTemplate(this.content, 'panlestyle');
      });
    }
    else {
      this.openModalTemplate(this.content, 'panlestyle');
    }
  }

  @ViewChild('AcceptTC') AcceptTC: TemplateRef<null>;
  isTCAccepted = true;
  private CheckIfUserAcceptedTC() {
    this.authService.isAuthenticatedACcount.subscribe(response1 => {
      if (response1) {
        this._userManagerService.GetTermsandConditionDetails().subscribe(res => {
          if (res != null) {
            this.TermsandConditionModified = this.Validation.convertUTCDateToLocalDate(parseDate(res));
          }
        });
        if (localStorage.getItem("isTCAccepted") == null) {
          this.isTCAccepted = false;
          this._userManagerService.CheckIfUserAcceptedTC(this.user.Id).subscribe(response => {
            this.isTCAccepted = response as boolean;
            if (!this.isTCAccepted) {
              this.authService.IsTcModalCalled = true;
              const config = {
                ignoreBackdropClick: true,
                class: 'modal-position commonmodal',
                keyboard: false,
                backdrop: true
              }
              this.modalRefTC = this.modalService.show(this.AcceptTC, config);
            }
            localStorage.setItem("isTCAccepted", JSON.stringify(this.isTCAccepted));
          });
        }
      }
    });
  }

  CheckIfUserAccepted1031TradeParticipationAgreement() {
    this.currentUser = this.authService.user;
    this._userManagerService.getUserDetails(this.currentUser.Guid).subscribe(res => {
      if (localStorage.getItem("isEBRAShown") == null) {
        if (res.IsEBRALinkSent && !res.IsEBRA_Accepted && this.isTCAccepted) {
          const config = {
            ignoreBackdropClick: true,
            class: 'deletemodal',
            keyboard: false,
            backdrop: true
          }
          this.modalIsEBRA = this.modalService.show(this.EBRAModal, config);
          localStorage.setItem("isEBRAShown", JSON.stringify(true));
        }
      }
    });
  }

  setHamburgerMenu() {
    //if (this.router.url.indexOf('propertylisting?') > -1) {
    //  this.CollapeMenu();
    //  this.openMenu();
    //}
  }

  ShowDealsBuy = false;
  bindUserSpecificMenu(userGuid) {
    if (this.userDetailsOutput != null && this.userDetailsOutput != undefined && this.userDetailsOutput.Is1031DashboardEnabled != null) {
      this.Is1031DashboardEnabled = this.userDetailsOutput.Is1031DashboardEnabled;
      this.Is1031InquirySubmitted = this.userDetailsOutput.Is1031InquirySubmitted;
      this.ShowDealsBuy = this.userDetailsOutput.ShowDealsBuy;
    }
    else {
      this._userManagerService.getUserDetails(userGuid).subscribe(response => {
        this.Is1031DashboardEnabled = response.Is1031DashboardEnabled;
        this.Is1031InquirySubmitted = response.Is1031InquirySubmitted;
        this.ShowDealsBuy = response.ShowDealsBuy;
      });
    }
  }

  async bindSaveSearchtoMenu() {
    let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
    await this._propertyListingService.getUsersavedSearch(loggedUserDetails.Id).subscribe((response: ISavedSearchOutputModel[]) => {
      this.savedSearchOutputModelList = response;
      if (this.savedSearchOutputModelList.length > 0 && this.canShowSaveSearch == true) {
        this.canShowSaveSearchText = false;
      }
      else {
        this.canShowSaveSearchText = true;
      }
    });
  }
  loggedInUserRoleToDisplay = "";
  loggedUserDetails: any;
  setLoggedInUserDetails() {
    this.loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
    this.loggedInUser = this.loggedUserDetails.FirstName + " " + this.loggedUserDetails.LastName;
    this.loggedInUserPic = this.loggedUserDetails.ProfilePicturePath;
    this.firstName = this.loggedUserDetails.FirstName;
    this.lastName = this.loggedUserDetails.LastName;
    this.email = this.loggedUserDetails.UserName;
    if (!this.isNotificationAPICalled) {
      this.isNotificationAPICalled = true;
      this.getUnreadNotificationCount();
    }
    if (!this.isNotificationMessageAPICalled) {
      this.isNotificationMessageAPICalled = true;
      this.getUnreadMessageCount();
    }
    if (this.authService.Broker()) {
      this.loggedInUserRoleToDisplay = environment.brokerRoleName;
    }
    else if (this.authService.Principal() || this.authService.Principal1031() || this.authService.Seller()) {
      this.loggedInUserRoleToDisplay = 'Principal';
    }
    else {
      this.loggedInUserRoleToDisplay = this.loggedUserDetails.Role;
    }
    this.loggedInUserRole = this.loggedUserDetails.Role;

    if (this.loggedInUserPic.trim().length <= 0) {
      this.loggedInUserPic = '/../../../assets/img/default-profile-img.png'
    }

    if (!this.isUserDetailsAPICalled) {
      this.isUserDetailsAPICalled = true;
      this.bindUserSpecificMenu(this.loggedUserDetails["Guid"]);
    }
  }

  deleteSavedSearch(id: string) {
    this._propertyListingService.deleteSavedSearch(id).subscribe(response => {
      if (response) {
        this._toastService.addToast({ title: 'Success', msg: 'Delete successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
        if (loggedUserDetails != null) {
          this._propertyListingService.getUsersavedSearch(loggedUserDetails.Id).subscribe((response: ISavedSearchOutputModel[]) => {
            this.savedSearchOutputModelList = response;
          });
        }
        this.canShowSaveSearchText = true;
      }
      else {
        this._toastService.addToast({ title: 'Error', msg: 'Unable to delete this item', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    });
  }

  onLogout() {
    // this.socialAuthService.signOut();
    // this._propertyListingService = {} as PropertyListingService;
    this._propertyListingService.criteria = {} as IPropertySearchCriteria;
    this._propertyListingService.criteria.PropertyFor = 601;
    this.authService.logoutClicked = true;
    this._toastService.addToast({ title: 'Success', msg: 'You are successfully logged out', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });

    $("body").removeClass("open-sidemenu");
    window.scrollTo(0, 0);
    if (this.authService.isAuth0Enabled) {
      this.Auth0.IsLogOut = true;
      this.Auth0.logout();
    }
    else {
      this.authService.logout();
      this.router.navigate(['/']);
    }
    //this.Validation.redirect('/');
  }

  showProfile() {
    let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
    if (this.router.url.indexOf('previouspage=PrincipalDashboard') > -1) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/my-profile'], { queryParams: { user: loggedUserDetails.Guid.toString() } }));
    }
    else {
      this.router.navigate(['/my-profile'], { queryParams: { user: loggedUserDetails.Guid.toString() } });
    }
  }

  openModal(template: TemplateRef<any>, classes: any) {
    if (this.authService.isAuth0Enabled && !this.Auth0.isRegistration) {
      this.Auth0.login();
    }
    else {
      this.Auth0.isRegistration = false;
      const config = {
        ignoreBackdropClick: true,
        class: 'modal-position ' + classes,
        keyboard: false,
        backdrop: true
      }

      this.modalRef = this.modalService.show(template, config);
    }
  }

  userInputGuid: string = '';

  openAuthenticationModal(template: TemplateRef<any>, classes: any) {
    this._loaderService.display(false);
    if (this.authService.IsCalledTheOtp == false) {
      this.Auth0.isRegistration = false;
      if (localStorage.getItem('userGuidForAuthentication') != null) {
        this.userInputGuid = JSON.parse(localStorage.getItem('userGuidForAuthentication'));
        localStorage.removeItem('userGuidForAuthentication');
      }
      const config = {
        ignoreBackdropClick: true,
        class: 'modal-position ' + classes,
        keyboard: false,
        backdrop: true
      }
      this.authService.IsCalledTheOtp = true;
      this.modalRef = this.modalService.show(template, config);
    }
  }

  viewPropertyWithSavedSearch(id: number) {
    this._loaderService.display(true)
    this.router.navigate(['/saved-search'], { queryParams: { search: id } });
    this._loaderService.display(false)
  }

  onViewFavoritesClick() {
    this.router.navigate(['/favourite'], { queryParams: { isFav: true } });
  }

  onViewDislikedClick() {
    this.router.navigate(['/dislike'], { queryParams: { isDisliked: true } });
  }

  onViewMessageClick() {
    this.router.navigate(['/Message']);
  }

  broker = false;
  admin = false;
  principal = false;
  principal1031 = false;
  externalBroker = false;
  dataEntryStaff = false;
  seller = false;
  superadmin = false;
  setMenuPermissions(role: string) {

    this.canShowUserMenu = false;
    this.canShowSaveSearch = false;
    this.canShow1031Trade = false;
    this.canShowFavorites = false;
    this.canShowOpportunities = false;
    this.canShowDocAccessRequest = false;
    this.canShowMyProperties = false;
    this.canShowMyOffers = false;
    this.canShowMy1031Exchange = false;
    this.canShowMasters = false;

    this.broker = false;
    this.admin = false;
    this.principal = false;
    this.principal1031 = false;
    this.externalBroker = false;
    this.dataEntryStaff = false;
    this.superadmin = false;

    if (this.authService.IsUserRole(this.authService.UserRole.Admin)) {
      this.admin = true;
    }
    else if (this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
      this.superadmin = true;
    }
    else if (this.authService.IsUserRole(this.authService.UserRole.Broker)) {
      this.broker = true;
    }
    else if (this.authService.IsUserRole(this.authService.UserRole.Principal1031)) {
      this.principal1031 = true;
    }
    else if (this.authService.IsUserRole(this.authService.UserRole.Principal)) {
      this.principal = true;
    }
    else if (this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
      this.externalBroker = true;
    }
    else if (this.authService.IsUserRole(this.authService.UserRole.DataEntryStaff)) {
      this.dataEntryStaff = true;
    }
    if (this.authService.IsUserRole(this.authService.UserRole.Seller)) {
      this.seller = true;
    }
    this.bindMenus = true;

    if (this.authService.Principal() || this.authService.Principal1031() || this.authService.ExternalBroker()) {

      if (!this.isTAndCAPICalled) {
        this.isTAndCAPICalled = true;
        this.CheckIfUserAcceptedTC();
      }
    }
  }
  hasAccess(GroupName, Name) {
    return this.Validation.hasAccess(GroupName, Name);
  }
  openLogOutModal(template: TemplateRef<any>, classes: any) {
    this.modalRef = this.modalService.show(template, { class: classes });
    $('.modal').addClass('logout-modal');
  }

  getTrakingCode() {
    this._propertyListingService.getTrackingCode().subscribe(responds => {
      gtag('config', responds);
    });
  }
  showOptions = false;
  onOptionsClick() {
    this.showOptions = !this.showOptions;
  }
  resetShowOptions() {
    this.showOptions = false;
  }
  subscriptionEmail = "";
  onSubmit(event) {
    event.preventdefault();
  }
  invalidSubscriptionEmail = false;
  checksubscriptionEmail(event) {
    if (this.Validation.isEmail(this.subscriptionEmail)) {
      this.invalidSubscriptionEmail = false;
    }
    else {
      this.invalidSubscriptionEmail = true;
    }
  }
  private extractData(res: Response) {
    let body = res.json();
    return body || {};
  }
  private handleErrorObservable(error: Response | any) {
    console.error(error.message || error);
    return observableThrowError(error.message || error);
  }
  private handleErrorPromise(error: Response | any) {
    console.error(error.message || error);
    return Promise.reject(error.message || error);
  }
  onSubscription() {
    let data = $('#mauticForm').serialize();
    //this.http.post<FormData>('https://mautic.benetlease.com/form/submit?formId=2', data, {}).subscribe(resp => {
    //    this._toastService.addToast({ title: 'Subscribed Successfully', msg: '', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
    //    this.subscriptionEmail = "";
    //    $("#drpClose").click();
    //});

    //let headers = new Headers({
    //    'Content-Type': 'application/json'
    //});
    //headers.append('Access-Control-Allow-Origin', '*');
    //headers.append('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept');
    //let options = new RequestOptions({ headers: headers });
    //return this.http.post('https://mautic.benetlease.com/form/submit?formId=2', data, options).toPromise().then(this.extractData).catch(this.handleErrorPromise);

    $.ajax({
      url: 'https://mautic.benetlease.com/form/submit?formId=2',
      type: 'post',
      dataType: 'json',
      data: data,
      success: function (data) { }
    });
    this._toastService.addToast({ title: 'Subscribed Successfully', msg: '', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
    this.subscriptionEmail = "";
    $("#drpClose").click();
  }

  unresolvedFlagCount = 0;
  modalRefunresolvedFlag: BsModalRef;
  currentUser: any;
  onLogin(loginStatus) {
    this.currentUser = this.authService.user;
    this.authService.isAuthenticatedACcount.subscribe(response1 => {
      if (response1) {
        this.PropertyManagement.GetFlaggedPropertyCount(this.currentUser.Id).subscribe(res => {
          if (res) {

            this.unresolvedFlagCount = parseInt(res.toString());

            if (this.unresolvedFlagCount > 0) {

              const config = {
                ignoreBackdropClick: true,
                class: 'deletemodal',
                keyboard: false,
                backdrop: true
              }
              this.modalRefunresolvedFlag = this.modalService.show(this.unresolvedFlagModal, config);
            }
          }
        });
      }
    });
  }

  //Add class to the header on scroll

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    let navElement = document.getElementsByClassName('main-header')[0];
    if (window.pageYOffset > 150) {
      navElement.classList.add('sticky');
    } else {
      navElement.classList.remove('sticky');
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadHandler(event: Event) {
    if (!this.isUserLoggedIn) {
      /* this.intercom.shutdown();*/
    }

    // used to check the application has ongoing file uploads
    if (localStorage.getItem('UploadedImageList') != null && localStorage.getItem('UploadedImageList') != '') {
      let UploadedFiles = JSON.parse(localStorage.getItem('UploadedImageList'));
      if (UploadedFiles != null && UploadedFiles.length > 0) {
        let ongoingList = UploadedFiles.filter(f => f.ImageStatus == '' || f.ImageStatus == null);
        if (ongoingList != null && ongoingList != undefined && ongoingList.length > 0) {
          event.returnValue = false;
        }
      }
    }
  }

  subscribe() {
    this.emailValidate()
    this.validatione(1)
    this.validatione(2)
    if (this.validFname && this.validLname && this.isValidEmail) {

      this.recaptchaExecute();
    }
  }

  submitSubscribe() {
    this._loaderService.display(true);
    var contact = {
      "FirstName": this.firstName,
      "LastName": this.lastName,
      "Email": this.email,
    };

    this._commonService.SubscribeEmail(contact).subscribe(res => {
      if (res)
        this.modalSubscribeRef.hide();
      this._loaderService.display(false);
      this._toastService.addToast({ title: 'Subscribed Successfully', msg: '', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
      if (!this.isUserLoggedIn) {
        this.email = "";
        this.firstName = "";
        this.lastName = "";
        this.companyName = "";
      }

    })
  }

  openSubscribeModal(template: TemplateRef<any>, classes: any) {
    const config = {
      class: 'news-letter-modal'
    }
    this.modalSubscribeRef = this.modalService.show(template, config);

  }
  emailValidate() {
    if (this.Validation.isEmail(this.email)) {
      this.isValidEmail = true;
    }
    else {
      this.isValidEmail = false;
    }
  }

  validatione(fieldType) {
    switch (fieldType) {
      case 1:
        if (this.firstName) {

          this.validFname = true;
        }
        else {
          this.validFname = false;

        }
        break;
      case 2:
        if (this.lastName) {
          this.validLname = true;
        }
        else {
          this.validLname = false;
        }
        break;
    }
  }

  recaptchaExecute() {
    let that = this;
    this.recaptchaV3Service.execute('subscribe')
      .subscribe((token) => {
        that._commonService.decodereCaptchaToken(token).subscribe(res => {
          if (res)
            console.log(res);
          if (res["Score"] > 0.5) {
            this.submitSubscribe()
          }
          //else {
          //this._toastService.addToast({ title: 'Please check captcha', msg: '', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
          //}
        })
      });
  }

  isAgreed = false;
  acceptTC() {
    this._loaderService.display(true);
    this._userManagerService.AcceptTandC(this.user.Id).subscribe(res => {
      if (res) {
        this.modalRefTC.hide();
        this.isTCAccepted = true;
        this.authService.IsTcModalCalled = false;
        this._toastService.addToast({
          title: 'Success', msg: 'B+E Terms & Conditions accepted successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
        })

        if (this.authService.Principal() || this.authService.Principal1031()) {
          this.Auth0.CheckIfUserAccepted1031TradeParticipationAgreement(this.user.Guid);
        }

        if (sessionStorage.getItem('currentRedirectUrl') != null) {
          let currentRedirectUrl = sessionStorage.getItem('currentRedirectUrl');
          if (currentRedirectUrl.indexOf('my-profile') > -1) {
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
              this.router.navigate(['/my-profile']));
          }
          else {
            this.router.navigateByUrl(currentRedirectUrl);
          }
          sessionStorage.removeItem('currentRedirectUrl');
        }
        if (this.authService.Principal() || this.authService.Principal1031() || this.authService.Broker() || this.authService.ExternalBroker()) {
          this.Auth0.CheckPendingBuyerQuestionnaire(this.user.Id);
        }
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to accept B+E Terms & Conditions', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        if (sessionStorage.getItem('currentRedirectUrl') != null) {
          sessionStorage.removeItem('currentRedirectUrl');
        }
      }
      this._loaderService.display(false);
    });
  }

  openModalTemplate(template: TemplateRef<any>, classes: any) {
    this.modalRef = this.modalService.show(template, { class: classes, backdrop: "static", keyboard: true });
    $('body').addClass('chat-modal-open');
  }

  openInvitePrincipal(template: TemplateRef<any>, classes: any) {
    this.modalRefInvitePrincipal = this.modalService.show(template, { class: classes });
  }


  /* starting region for messagin */

  openNewChatPopup(ngClass: string, addLocalStorage = false) {

    var splitted = ngClass.split(/_(.+)/);
    var check = "0_" + splitted[1];
    const index1: number = this.openChats.indexOf(check);
    {
      this.removeClass(check);
    }

    if (addLocalStorage) {
      const index: number = this.openChats.indexOf(ngClass);
      if (index === -1) {
        this.openChats.push(ngClass);
      }

      localStorage.setItem('openChats', JSON.stringify(this.openChats));
    }
    $('#location_' + ngClass).addClass('popup-box-on');


  }


  removeClass(ngClass) {

    const index: number = this.openChats.indexOf(ngClass);
    if (index !== -1) {
      this.openChats.splice(index, 1);
    }

    localStorage.setItem('openChats', JSON.stringify(this.openChats));
    $('#location_' + ngClass).removeClass('popup-box-on');
  }

  closeModal() {
    this.property = {} as IPropertyDetails;
    this.exchangeId = 0;
    this.modalRef.hide();
  }
  openChatPopup(item: AllReceivedMessageTimeline, openPopup = true) {

    this.messageInput.CreatedById = this.user.Id;
    this.messageInput.ExchangeId = item.ExchangeId == null ? 0 : item.ExchangeId;
    this.messageInput.RecipientId = item.UserId;
    this.messageInput.MessageGroupId = item.MessageGroupId;

    this._commonService.getMessagesList(this.messageInput).subscribe(response => {
      this.messages.filter(i => i.GroupName == item.GroupName)[0].MessageList = response;
      this.messages.filter(i => i.GroupName == item.GroupName)[0].showChild = true;
      if (item.IsGroup) {
        var objectId = item.ObjectId == null ? 0 : item.ObjectId;
        var exchangeId = item.ExchangeId == null ? 0 : item.ExchangeId;
        this._commonService.getAllGroupMembers(item.MessageGroupId, this.user.Id, exchangeId, objectId).subscribe(resp => {
          this.messages.filter(i => i.GroupName == item.GroupName)[0].GroupMembers = resp;
          //if (item.Suppress != true) {
          //  this.messageGroupMember = {} as IMessageGroupMemberInputModel;
          //  this.messageGroupMember.MemberId = this.user.Id;
          //  this.messageGroupMember.Id = 1;
          //  this.messageGroupMember.Name = 'You';
          //  this.messageGroupMember.GroupId = 0;
          //  this.messages.filter(i => i.GroupName == item.GroupName)[0].GroupMembers.push(this.messageGroupMember);
          //}
        });
      }
      this.getUnreadMessageCount();
    });
    if (openPopup) {
      var name = item.GroupName;

      this.openNewChatPopup(name, true);
      setTimeout(() => {

        $('#popup_' + item.GroupName).scrollTop($('#popup_' + item.GroupName)[0].scrollHeight);
      }, 1000);

    }
    else {
      setTimeout(() => {

        $('#popup_' + item.GroupName).scrollTop($('#popup_' + item.GroupName)[0].scrollHeight);
      }, 1000);
    }
  }
  refresh(item) {
    this.openChatPopup(item, false);
  }

  async getUnreadMessageCount() {
    await this._commonService.getUnreadMessageCount(this.user.Id).subscribe(response => {
      this.totalUnReadMessages = response["IndividualMessageCount"] + response["GroupMessageCount"];
      this.totalUnreadGroupMessages = response["GroupMessageCount"];
      this.totalUnreadIndividualMessages = response["IndividualMessageCount"];
    })
  }
  notificationRequestModel = {} as NotificationRequestModel;
  showProcessingMessage: boolean = true;
  getNotification() {
    this.showProcessingMessage = true;
    this.notificationRequestModel.LoggedInUserId = this.user.Id;
    this.notificationRequestModel.Count = 5;
    this.notificationRequestModel.UserId = 0;
    this._commonService.getNotification(this.notificationRequestModel).subscribe(response => {
      this.showProcessingMessage = false;
      this.notifications = response;
    })
  }

  checkOpenExchange() {

    this._userManagerService.CheckUserHasOpenedExchange(this.user.Id).subscribe(response => {
      this.hasOpenedExchange = response;
    });
  }

  allMessageEvent(item: AllReceivedMessageTimeline[]) {
    console.log(item);
    if (this.messages != undefined && this.messages.length > 0) {
      item.forEach(val => {
        var data = this.messages.filter(i => i.GroupName == val.GroupName).length;
        if (data == 0) {
          this.messages.push(val);
        }
      });
    }
    else {
      this.messages = item;
    }
    this.loadPopus = true;

  }

  leaveGroupEvent(item: AllReceivedMessageTimeline) {
    if (this.messages != undefined && this.messages.length > 0) {
      const index = this.messages.filter(i => i.ChatIdentifier == item.ChatIdentifier);
      if (index.length > 0) {
        this.messages.filter(i => i.ChatIdentifier == item.ChatIdentifier)[0].Suppress = true;
      }
    }
  }

  public onSearch(query: string, item) {
    item.MessageGroupId = item.MessageGroupId == null ? 0 : item.MessageGroupId;
    this._commonService.getPropertIds(this.user.RoleId, this.user.Id, item.UserId, item.MessageGroupId, query).subscribe(data => {

      data.forEach(item => {
        item.id = item.Id;
        item.name = item.Name;
      });
      item.PropertyTagSuggestions = data;
    });

  }

  replaceAll = function (data, search, replace) {
    return data.replace(new RegExp(search, 'g'), replace)
  }
  saveMessage(item, msg) {
    if (item.CurrentMessage != null && item.CurrentMessage != undefined && item.CurrentMessage.replace(/\s*$/, '') != '' && item.CurrentMessage.length > 0) {
      if (item.IsGroup && item.MessageGroupId == 0) {
        this.addNewGroup(item);
      }
      else {
        msg = item.CurrentMessage;
        this.messageInput.CreatedById = this.user.Id;
        this.messageInput.ExchangeId = item.ExchangeId == null ? 0 : item.ExchangeId;
        this.messageInput.MessageGroupId = item.MessageGroupId == null ? 0 : item.MessageGroupId;
        this.messageInput.RecipientId = item.UserId;
        this.messageInput.MessageDescription = msg;
        if (!this.Validation.IsinValid(this.messageInput)) {
          this._commonService.SaveMessages(this.messageInput).subscribe(responds => {
            if (responds.IsSuccess) {
              this.messages.filter(i => i.GroupName == item.GroupName)[0].MessageList.push({
                CreatedOn: new Date(),
                Id: 0,
                IsSender: 1,
                MessageDescription: msg,
                ReadMessage: false,
                Sender: this.user.FirstName + " " + this.user.LastName,
                ImagePath: ""
              })
              this.messages.filter(i => i.GroupName == item.GroupName)[0].CurrentMessage = "";
              this.refresh(item);
              this.messageInput.TaggedPropertyId = [];
              this.sharedService.setrefreshMessage(true);
              setTimeout(() => {
                $('#popup_' + item.GroupName).scrollTop($('#popup_' + item.GroupName)[0].scrollHeight);
              }, 500);
            }
          });
        }
      }
    }
  }

  addNewGroup(item) {
    if (this.propertyContactPerson.length != 0) {
      for (let i = 0; i < this.propertyContactPerson.length; i++) {
        this.messageGroupMembers.push({
          Id: 1,
          MemberId: this.propertyContactPerson[i].UserId,
          GroupId: 0,
          Name: null,
          Photo: null
        })
      }
    }
    this.messageGroupMember = {} as IMessageGroupMemberInputModel;
    this.messageGroupMember.MemberId = this.user.Id;
    this.messageGroupMember.Id = 0;
    this.messageGroupMember.GroupId = 0;
    this.messageGroupMembers.push(this.messageGroupMember);

    this.messageGroupSingleData.Id = item.messageGroupId == undefined ? 0 : item.messageGroupId;
    this.messageGroupSingleData.GroupName = item.DisplayName;
    this.messageGroupSingleData.ObjectTypeId = 1;
    this.messageGroupSingleData.ObjectId = item.ObjectId;
    this.messageGroupSingleData.LoggedInUserId = this.user.Id;
    this.messageGroupSingleData.ExchangeId = item.ExchangeId == null ? 0 : item.ExchangeId;
    this.messageGroupDataLst.LoggedInUserId = this.user.Id;
    this.messageGroupDataLst.MessageGroup = this.messageGroupSingleData;
    this.messageGroupDataLst.LoggedInUserId = this.user.Id;
    this.messageGroupDataLst.MessageGroupMembers = this.messageGroupMembers;
    this.messageGroupDataLst.MessageGroup.IsActiveId = 101;
    this.messageGroupDataLst.MessageGroup.IsGroupAdmin = true;
    this._commonService.SaveMessageGroupAndMembers(this.messageGroupDataLst).subscribe(responds => {
      item.MessageGroupId = responds;
      this.saveMessage(item, null);
    });
  }


  /* Ending region for messagin */

  onTCClose() {
    this.modalRefTC.hide();
    this.messages = [];
    if (sessionStorage.getItem('currentRedirectUrl') != null) {
      sessionStorage.removeItem('currentRedirectUrl');
    }
    this.onLogout();
  }
  viewNotification() {
    this.router.navigate(['/notification/list']);
  }

  notificationCount = 0;
  isNotificationAPICalled: boolean = false;
  isNotificationMessageAPICalled: boolean = false;
  isOpenExchangeAPICalled: boolean = false;
  isUserSearchAPICalled: boolean = false;
  isUserDetailsAPICalled: boolean = false;
  isCheckMyPortfolioAPICalled: boolean = false;
  isTAndCAPICalled: boolean = false;
  async getUnreadNotificationCount() {
    if (this.user != null) {
      await this._commonService.getUnreadNotificationCount(this.user.Id).subscribe(responds => {
        this.notificationCount = Number(responds);
      });
    }
  }
  deleteNotification(id) {
    this._commonService.deleteNotification(id, this.user.Id).subscribe(response => {
      this.getNotification();
    })
  }

  markasRead(notificationid) {
    //var selectedIds = [];
    //selectedIds.push(notificationid);
    this.notificationAction.Ids = [];
    this.notificationAction.Ids[0] = notificationid;
    this.notificationAction.UserId = this.user.Id;
    this.notificationAction.MarkAll = false;
    this.notificationAction.MarkAsRead = true;
    this._commonService.readNotification(this.notificationAction).subscribe(response => {
      this.getNotification();
    })
  }

  CheckPendingBuyerQuestionnaire() {
    this._userManagerService.CheckPendingBuyerQuestionnaire(this.user.Id).subscribe(res => {
      this.isPendingBuyerQuestions = res as boolean;
      if (this.isPendingBuyerQuestions == true) {
        const config = {
          ignoreBackdropClick: true,
          class: 'modal-position commonmodal questionnaire-login-modal',
          keyboard: false,
          backdrop: true
        }
        this.modalBuyerQuestionnaire = this.modalService.show(this.pendingBuyerQuestionnaireFlagModal, config);
      }
    });
  }
  GetBuyerQuestionnaireRedirection() {
    let redirectionLink = '';
    if (this.authService.Principal() || this.authService.ExternalBroker()) {
      redirectionLink = '/placed-offers';
    }
    else if (this.authService.Principal1031()) {
      redirectionLink = '/deals-buy';

    }
    else if (this.authService.Broker()) {
      redirectionLink = '/offers-placed';

    }
    this.router.navigateByUrl(redirectionLink);
  }
  async CheckMyPortfolioAccess() {
    if (this.authService.Principal() || this.authService.Principal1031() || this.authService.Seller()) {
      await this._propertyListingService.CheckMyportfolioAccess(this.user.Id).subscribe(res => {
        this.hasMyportfolioAccess = res as boolean;
      });
    }
  }

  checkMasterModulePermissions() {
    let status =
      this.permissionService.hasPermission(Modules.TaskMaster, Actions.Listings) ||
      this.permissionService.hasPermission(Modules.City, Actions.Listings) ||
      this.permissionService.hasPermission(Modules.Brokerages, Actions.Listings) ||
      this.permissionService.hasPermission(Modules.PropertyType, Actions.Listings) ||
      this.permissionService.hasPermission(Modules.TenantMaster, Actions.Listings) ||
      this.permissionService.hasPermission(Modules.GuarantorMaster, Actions.Listings) ||
      this.permissionService.hasPermission(Modules.DealTeamContactType, Actions.Listings) ||
      this.permissionService.hasPermission(Modules.ExpenseMaster, Actions.Listings) ||
      this.permissionService.hasPermission(Modules.MetaTag, Actions.Listings) ||
      this.permissionService.hasPermission(Modules.FileCategory, Actions.Listings);
    return status;
  }
}
